module.exports = __webpack_public_path__ + "img/Roboto-Light.69a7b29.svg";